


// Service

const SERVICE_STORE_ID = 'service'

const SERVICE_DAEMON_VARIABLE_TABLE_STORE_ID_LIST = [SERVICE_STORE_ID, 'daemon-variable-table']
const SERVICE_DAEMON_VARIABLE_TABLE_STORE_ID = SERVICE_DAEMON_VARIABLE_TABLE_STORE_ID_LIST.join('/')


// Service Account

const SERVICE_ACCOUNT_STORE_ID = 'service-account'

const SERVICE_ACCOUNT_STORE_ID_LIST = [SERVICE_ACCOUNT_STORE_ID, 'service-account-variable-table']
const SERVICE_ACCOUNT_VARIABLE_TABLE_STORE_ID = SERVICE_ACCOUNT_STORE_ID_LIST.join('/')

const SERVICE_DATA_QUEUE_STORE_ID = 'service-data-queue'

// Digital Currency Account

const DIGITAL_CURRENCY_ACCOUNT_STORE_ID = 'digital-currency-account'

const DIGITAL_CURRENCY_ACCOUNT_VARIABLE_TABLE_STORE_ID_LIST = [DIGITAL_CURRENCY_ACCOUNT_STORE_ID, 'digital-currency-account-variable-table']
const DIGITAL_CURRENCY_ACCOUNT_VARIABLE_TABLE_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_VARIABLE_TABLE_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_ACCOUNT_DESCRIPTION_VARIABLE_TABLE_STORE_ID_LIST = [DIGITAL_CURRENCY_ACCOUNT_STORE_ID, 'digital-currency-account-description-variable-table']
const DIGITAL_CURRENCY_ACCOUNT_DESCRIPTION_VARIABLE_TABLE_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_DESCRIPTION_VARIABLE_TABLE_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_ACCOUNT_GROUPS_VARIABLE_TABLE_STORE_ID_LIST = [DIGITAL_CURRENCY_ACCOUNT_STORE_ID, 'digital-currency-account-groups-variable-table']
const DIGITAL_CURRENCY_ACCOUNT_GROUPS_VARIABLE_TABLE_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_GROUPS_VARIABLE_TABLE_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_ACCOUNT_SETTINGS_STORE_ID_LIST = [DIGITAL_CURRENCY_ACCOUNT_STORE_ID, 'digital-currency-account-settings-variable-table']
const DIGITAL_CURRENCY_ACCOUNT_SETTINGS_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_SETTINGS_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_ACCOUNT_NETWORK_STATISTICS_STORE_ID_LIST = [DIGITAL_CURRENCY_ACCOUNT_STORE_ID, 'digital-currency-account-network-statistics']
const DIGITAL_CURRENCY_ACCOUNT_NETWORK_STATISTICS_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_NETWORK_STATISTICS_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_ACCOUNT_NOTIFICATIONS_VARIABLE_TABLE_STORE_ID_LIST = [DIGITAL_CURRENCY_ACCOUNT_STORE_ID, 'digital-currency-account-notifications-variable-table']
const DIGITAL_CURRENCY_ACCOUNT_NOTIFICATIONS_VARIABLE_TABLE_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_NOTIFICATIONS_VARIABLE_TABLE_STORE_ID_LIST.join('/')



// Digital Currency Transaction


const DIGITAL_CURRENCY_TRANSACTION_STORE_ID = 'digital-currency-transaction'

const DIGITAL_CURRENCY_TRANSACTION_VARIABLE_TABLE_STORE_ID_LIST = [DIGITAL_CURRENCY_TRANSACTION_STORE_ID, 'digital-currency-transaction-variable-table']
const DIGITAL_CURRENCY_TRANSACTION_VARIABLE_TABLE_STORE_ID = DIGITAL_CURRENCY_TRANSACTION_VARIABLE_TABLE_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_TRANSACTION_NETWORK_STATISTICS_STORE_ID_LIST = [DIGITAL_CURRENCY_TRANSACTION_STORE_ID, 'digital-currency-transaction-network-statistics']
const DIGITAL_CURRENCY_TRANSACTION_NETWORK_STATISTICS_STORE_ID = DIGITAL_CURRENCY_TRANSACTION_NETWORK_STATISTICS_STORE_ID_LIST.join('/')

const DIGITAL_CURRENCY_ACCOUNT_TRANSACTION_STATISTICS_VARIABLE_TABLE_STORE_ID_LIST = [DIGITAL_CURRENCY_TRANSACTION_STORE_ID, 'digital-currency-account-transaction-statistics-variable-table']
const DIGITAL_CURRENCY_ACCOUNT_TRANSACTION_STATISTICS_VARIABLE_TABLE_STORE_ID = DIGITAL_CURRENCY_ACCOUNT_TRANSACTION_STATISTICS_VARIABLE_TABLE_STORE_ID_LIST.join('/')




// Product Resource

const PRODUCT_RESOURCE_STORE_ID = 'product-resource'


// Job Employment Resource

const JOB_EMPLOYMENT_RESOURCE_STORE_ID = 'job-employment-resource'


// Currency Exchange Resource

const CURRENCY_EXCHANGE_RESOURCE_STORE_ID = 'currency-exchange-resource'


// Digital Currency Alternative Resource

const DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_STORE_ID = 'digital-currency-alternative-resource'



export {

  // Service
  SERVICE_STORE_ID,

  SERVICE_DAEMON_VARIABLE_TABLE_STORE_ID_LIST,
  SERVICE_DAEMON_VARIABLE_TABLE_STORE_ID,

  // Service Account
  SERVICE_ACCOUNT_STORE_ID,

  SERVICE_ACCOUNT_STORE_ID_LIST,
  SERVICE_ACCOUNT_VARIABLE_TABLE_STORE_ID,

  SERVICE_DATA_QUEUE_STORE_ID,

  // Digital Currency Account
  DIGITAL_CURRENCY_ACCOUNT_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_VARIABLE_TABLE_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_VARIABLE_TABLE_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_DESCRIPTION_VARIABLE_TABLE_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_DESCRIPTION_VARIABLE_TABLE_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_GROUPS_VARIABLE_TABLE_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_GROUPS_VARIABLE_TABLE_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_SETTINGS_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_SETTINGS_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_NETWORK_STATISTICS_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_NETWORK_STATISTICS_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_NOTIFICATIONS_VARIABLE_TABLE_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_NOTIFICATIONS_VARIABLE_TABLE_STORE_ID,

  // Digital Currency Transaction

  DIGITAL_CURRENCY_TRANSACTION_STORE_ID,

  DIGITAL_CURRENCY_TRANSACTION_VARIABLE_TABLE_STORE_ID_LIST,
  DIGITAL_CURRENCY_TRANSACTION_VARIABLE_TABLE_STORE_ID,

  DIGITAL_CURRENCY_TRANSACTION_NETWORK_STATISTICS_STORE_ID_LIST,
  DIGITAL_CURRENCY_TRANSACTION_NETWORK_STATISTICS_STORE_ID,

  DIGITAL_CURRENCY_ACCOUNT_TRANSACTION_STATISTICS_VARIABLE_TABLE_STORE_ID_LIST,
  DIGITAL_CURRENCY_ACCOUNT_TRANSACTION_STATISTICS_VARIABLE_TABLE_STORE_ID,


  // Product Resource

  PRODUCT_RESOURCE_STORE_ID,

  // Job Employment Resource

  JOB_EMPLOYMENT_RESOURCE_STORE_ID,

  // Currency Exchange Resource

  CURRENCY_EXCHANGE_RESOURCE_STORE_ID,

  // Digital Currency Alternative Resource

  DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_STORE_ID
}



